import { render, staticRenderFns } from "./groupuser.vue?vue&type=template&id=169e8bf4&"
import script from "./groupuser.vue?vue&type=script&lang=js&"
export * from "./groupuser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports